import { render } from "./MaterialsView.vue?vue&type=template&id=1004ff7f&scoped=true"
import script from "./MaterialsView.vue?vue&type=script&lang=js"
export * from "./MaterialsView.vue?vue&type=script&lang=js"

import "./MaterialsView.vue?vue&type=style&index=0&id=1004ff7f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1004ff7f"]])

export default __exports__